import {
  OrderDirection,
  commonMutationTypes,
  pageInfo,
  userDetails,
} from "../../../../../../utils/commonQueryTypes";
import { AtsAcLdgr } from "../../supplier/queries/types";

export interface AddProjectResult {
  AddProject: {
    id: number;
  };
}

export interface CreateAtsAcLdgrProjects {
  name: string;
  workOrderNum: string;
  contractValue: number;
  projectScope: string;
  contractSignedWith: string;
  loa: string;
  agreementDate: string;
  startDate: string;
  endDate: string;
  insuranceStartDate: string;
  insuranceEndDate: string;
  goLiveDate: string;
  amcStartDate: string;
  amcScope: string;
  amcInsuranceStartDate: string;
  amcInsuranceEndDate: string;
  dlpStartDate: string;
  dlpEndDate: string;
  bgValue: number;
  bgStartDate: string;
  bgEndDate: string;
  slaBillingCycle: string;
  agreementFile: string;
  endAgreementFile: string;
}

export interface AddProjectVar extends commonMutationTypes {
  customerID: number;
  ldgrID: number;
  input: CreateAtsAcLdgrProjects;
}

export interface UpdateAtsAcLdgrProjects extends CreateAtsAcLdgrProjects {
  ldgrID: number;
}

export interface UpdateProjectVar extends commonMutationTypes {
  customerID: number;
  projectID: number;
  input: UpdateAtsAcLdgrProjects;
}

export interface UpdateProjectResult {
  UpdateProject: {
    id: number;
  };
}

export interface AtsAcLdgrProjects {
  id: number;
  name: string;
  contractValue: number;
  projectScope: string;
  workOrderNum: string;
  contractSignedWith: string;
  loa: string;
  agreementDate: string;
  startDate: string;
  endDate: string;
  insuranceStartDate: string;
  insuranceEndDate: string;
  goLiveDate: string;
  amcStartDate: string;
  amcScope: string;
  amcInsuranceStartDate: string;
  amcInsuranceEndDate: string;
  dlpStartDate: string;
  dlpEndDate: string;
  bgValue: number;
  bgStartDate: string;
  bgEndDate: string;
  slaBillingCycle: string;
  agreementFile: string;
  endAgreementFile: string;
  customerID: number;
  ldgrID: number;
  supplierName: AtsAcLdgr;
}

export interface AtsAcLdgrProjectsEdge {
  node: AtsAcLdgrProjects;
  cursor: string;
}

export interface AtsAcLdgrProjectsConnection {
  edges: AtsAcLdgrProjectsEdge[];
  pageInfo: pageInfo;
  totalCount: number;
}

export interface GetProjectsResult {
  GetProjects: AtsAcLdgrProjectsConnection;
}

export enum AtsAcLdgrProjectsOrderField {
  CREATED_AT = "CREATED_AT",
}

export interface AtsAcLdgrProjectsOrder {
  direction: OrderDirection;
  field: AtsAcLdgrProjectsOrderField;
}

export interface GetProjectsVar {
  token?: string;
  customerID: number;
  empID: number;
  after: string | null;
  first: number;
  orderBy: AtsAcLdgrProjectsOrder;
  name: string;
}

export interface DeleteProjectResult {
  DeleteProject: boolean;
}

export interface DeleteProjectVar extends commonMutationTypes {
  customerID: number;
  projectID: number;
}

export interface AddProjectHeaderVar extends commonMutationTypes {
  header: string;
  initData: boolean;
  projectID: number;
  customerID: number;
  dataType: string;
}

export interface AddProjectHeaderResult {
  AddProjectHeader: boolean;
}

export interface ProjectData {
  projectDetails: AtsAcLdgrProjects;
  headerCount: number;
}
export interface GetProjectsTableHeaderCountResult {
  GetProjectsTableHeaderCount: ProjectData[];
}

export interface GetProjectsTableHeaderCountVar {
  customerID: number;
  empID: number;
  toAddHeaders: boolean
}

export interface AtsProjectHeaders {
  id: number;
  idx: number;
  header: string;
  initData: boolean;
  projectID: number;
  ldgrID: number;
  dataType: string;
  customerID: number;
}

export interface GetProjectsHeadersResult {
  GetProjectsHeaders: AtsProjectHeaders[];
}

export interface GetProjectsHeadersVar {
  customerID: number;
  projectID: number;
}

export interface UpdateProjectHeaderVar extends commonMutationTypes {
  header: string;
  initData: boolean;
  dataType: string;
  projectHeaderID: number;
  status: boolean;
  customerID: number;
}

export interface UpdateProjectHeaderResult {
  UpdateProjectHeader: boolean;
}

export interface DeleteProjectHeaderVar extends commonMutationTypes {
  projectHeaderID: number;
  customerID: number;
}

export interface DeleteProjectHeaderResult {
  DeleteProjectHeader: boolean;
}

export interface AtsProjectHeaders {
  id: number;
  idx: number;
  header: string;
  initData: boolean;
  dataType: string;
  status: boolean;
  projectID: number;
  ldgrID: number;
  customerID: number;
}

export interface ReOrderHeaders {
  projectHeaderID: number;
  idx: number;
}

export interface ReOrderProjectHeaderVar extends commonMutationTypes {
  customerID: number;
  input: ReOrderHeaders[];
}

export interface ReOrderProjectHeaderResult {
  ReOrderProjectHeader: boolean;
}

export interface AtsProjectDailyReports {
  id: number;
  reportDate: string;
  count: number;
  param1: string;
  param2: string;
  param3: string;
  param4: string;
  param5: string;
  param6: string;
  param7: string;
  param8: string;
  param9: string;
  param10: string;
  param11: string;
  param12: string;
  param13: string;
  param14: string;
  param15: string;
  param16: string;
  param17: string;
  param18: string;
  param19: string;
  param20: string;
  param21: string;
  param22: string;
  param23: string;
  param24: string;
  param25: string;
  pmuRemarks: string;
}

export interface AtsProjectDailyReportsEdge {
  node: AtsProjectDailyReports;
  cursor: string;
}

export interface AtsProjectDailyReportsConnection {
  edges: AtsProjectDailyReportsEdge[];
  pageInfo: pageInfo;
  totalCount: number;
}

export interface GetProjectDailyReportsResult {
  GetProjectDailyReports: AtsProjectDailyReportsConnection;
}

export enum AtsProjectDailyReportsOrderField {
  REPORT_DATE = "REPORT_DATE",
}

export interface AtsProjectDailyReportsOrder {
  direction: OrderDirection;
  field: AtsProjectDailyReportsOrderField;
}

export interface GetProjectDailyReportsVar {
  token?: string;
  customerID: number;
  after: string | null;
  first: number;
  startDate?: string;
  endDate?: string;
  projectID: number;
  orderBy: AtsProjectDailyReportsOrder;
}

export interface AddProjectPmuRemarkVar extends commonMutationTypes {
  pmuRemarks: string;
  reportDate: string;
  projectID: number;
  customerID: number;
  user_details: userDetails;
}

export interface AddProjectPmuRemarkResult {
  AddProjectPmuRemark: boolean;
}

export interface AtsProjectInitDataInput {
  idx: number;
  param: string | number | boolean;
}

export interface CheckProjectAnyInitHeaderResult {
  CheckProjectAnyInitHeader: boolean;
}

export interface CheckProjectAnyInitHeaderVar {
  customerID: number;
  projectID: number;
}

export interface AtsAddOrUpdateProjectDailyReportsVar
  extends commonMutationTypes {
  reportDate: string;
  input: AtsProjectInitDataInput[];
  projectID: number;
  customerID: number;
  user_details: userDetails;
}

export interface AddProjectDailyReportsResult {
  AddProjectDailyReports: boolean;
}

export interface UpdateProjectDailyReportsResult{
  UpdateProjectDailyReports:boolean
}

export interface UpdateProjectDailyReportsVar extends commonMutationTypes {
  AtsProjectDailyReportsID: number;
  input: AtsProjectInitDataInput[]
  projectID: number;
  customerID: number;
}

export interface AddProjectDailyReportsVar extends commonMutationTypes {
  reportDate: string;
  input: AtsProjectInitDataInput[];
  projectID: number;
  customerID: number;
  user_details: userDetails;
}

export interface AtsAddOrUpdateProjectInitDataVar extends commonMutationTypes{
  reportDate: string;
  input: AtsProjectInitDataInput[];
  projectID: number;
  customerID: number;
  user_details: userDetails;
}


export interface AtsAddOrUpdateProjectInitDataResult {
  AtsAddOrUpdateProjectInitData: boolean;
}

export interface CheckProjectDailyReportStartedResult {
  CheckProjectDailyReportStarted: boolean;
}

export interface CheckProjectDailyReportStartedVar {
  customerID: number;
  projectID: number;
}

export interface UpdateProjectPmuRemarkVar extends commonMutationTypes {
  pmuRemarks: string;
  AtsProjectDailyReportsID: number;
  customerID: number;
}

export interface UpdateProjectPmuRemarkResult {
  UpdateProjectPmuRemark: boolean;
}

export interface AtsProjectDailyReportsByIdResult {
  node: AtsProjectDailyReports;
}
